import React, { useState } from 'react';
import { uploadArquivo } from '../arquivos';
import {
  GRUPOS_TEXTOS, VALORES_PADRAO, TIMELINE_PADRAO, UNIDADES_PADRAO, CORES_TEMA, estiloDoTema,
} from './inepPersonalizacao';
import { RODAPE_PADRAO } from './InepRodape';

// Tela "Personalização" do admin do INEP. Edita um rascunho (draft) de inep_config/geral;
// nada vale para os alunos até clicar em "Salvar".

const ABAS = [
  ['inicio', '🏠 Tela inicial'],
  ['cores', '🎨 Cores e logo'],
  ['textos', '✏️ Textos'],
  ['quemsomos', '🏥 Quem somos'],
  ['rodape', '🔗 Rodapé'],
];

function Campo({ rotulo, children, dica }) {
  return (
    <div className="inep-f-field" style={{ marginBottom: 12 }}>
      <label>{rotulo}</label>{children}{dica && <small style={{ color: 'var(--muted)', display: 'block', marginTop: 3 }}>{dica}</small>}
    </div>
  );
}

// Editor de lista (valores, linha do tempo, unidades): cada item com seus campos
function ListaEditavel({ itens, campos, onChange, novo }) {
  const mudar = (i, campo, valor) => onChange(itens.map((it, j) => (j === i ? { ...it, [campo]: valor } : it)));
  const mover = (i, d) => { const n = [...itens]; const [x] = n.splice(i, 1); n.splice(i + d, 0, x); onChange(n); };
  return (
    <div>
      {itens.map((it, i) => (
        <div key={i} className="inep-card" style={{ marginBottom: 8, padding: 12, display: 'flex', gap: 8, alignItems: 'flex-start', flexWrap: 'wrap' }}>
          {campos.map(([campo, rotulo, tipo, largura]) => (
            <div key={campo} style={{ flex: largura || 1, minWidth: tipo === 'color' ? 60 : 140 }}>
              <small style={{ color: 'var(--muted)', fontWeight: 700 }}>{rotulo}</small>
              {tipo === 'color'
                ? <input type="color" value={it[campo] || '#0878b9'} onChange={e => mudar(i, campo, e.target.value)} style={{ width: '100%', height: 36, border: 0, background: 'none' }} />
                : <input value={it[campo] || ''} onChange={e => mudar(i, campo, e.target.value)} style={{ width: '100%', padding: '7px 9px', border: '1.5px solid var(--line)', borderRadius: 8, background: 'var(--card)', color: 'var(--ink)' }} />}
            </div>
          ))}
          <div style={{ display: 'flex', gap: 4, alignSelf: 'flex-end' }}>
            <button className="inep-add-aula" disabled={i === 0} onClick={() => mover(i, -1)} title="Subir">↑</button>
            <button className="inep-add-aula" disabled={i === itens.length - 1} onClick={() => mover(i, 1)} title="Descer">↓</button>
            <button className="inep-rm-btn" onClick={() => onChange(itens.filter((_, j) => j !== i))} title="Remover">✕</button>
          </div>
        </div>
      ))}
      <button className="inep-add-aula" onClick={() => onChange([...itens, novo()])}>+ Adicionar</button>
    </div>
  );
}

export default function InepPersonalizacaoAdmin({ draft, setDraft, salvar, heroPadrao, cursosCores }) {
  const [aba, setAba] = useState('inicio');
  const [aviso, setAviso] = useState('');
  const [enviando, setEnviando] = useState('');
  const [buscaTexto, setBuscaTexto] = useState('');

  const set = (campo, valor) => setDraft(d => ({ ...d, [campo]: valor }));
  const setTexto = (k, v) => setDraft(d => ({ ...d, textos: { ...(d.textos || {}), [k]: v } }));
  const setCor = (k, v) => setDraft(d => ({ ...d, cores: { ...(d.cores || {}), [k]: v } }));
  const setQS = (k, v) => setDraft(d => ({ ...d, quemSomos: { ...(d.quemSomos || {}), [k]: v } }));
  const rod = { ...RODAPE_PADRAO, ...(draft.rodape || {}) };
  const setRod = (k, v) => setDraft(d => ({ ...d, rodape: { ...RODAPE_PADRAO, ...(d.rodape || {}), [k]: v } }));

  const salvarTudo = async () => {
    setAviso('Salvando…');
    try { await salvar(); setAviso('✓ Salvo — os alunos já veem as mudanças'); setTimeout(() => setAviso(''), 3000); }
    catch (e) { setAviso('Erro ao salvar: ' + e.message); }
  };
  const enviar = async (file, pasta, campo) => {
    if (!file) return;
    setEnviando(campo);
    try { const { url } = await uploadArquivo(file, pasta); set(campo, url); }
    catch (e) { alert('Erro ao enviar: ' + e.message); }
    finally { setEnviando(''); }
  };

  const estiloPrevia = estiloDoTema(draft.cores, 'light');
  const q = buscaTexto.trim().toLowerCase();

  return (
    <div>
      <div className="inep-dtabs">
        {ABAS.map(([id, rotulo]) => <button key={id} className={aba === id ? 'inep-sel' : ''} onClick={() => setAba(id)}>{rotulo}</button>)}
      </div>

      {aba === 'inicio' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr', gap: 18 }}>
          <div className="inep-card">
            <h3>Destaque da tela inicial</h3>
            <Campo rotulo="Título de destaque"><input value={draft.heroTitulo ?? heroPadrao.titulo} onChange={e => set('heroTitulo', e.target.value)} /></Campo>
            <Campo rotulo="Texto de apoio"><textarea rows={3} value={draft.heroTexto ?? heroPadrao.texto} onChange={e => set('heroTexto', e.target.value)} /></Campo>
            <Campo rotulo="Vídeo de boas-vindas (YouTube)" dica="Aparece na tela inicial do aluno, logo abaixo do destaque."><input value={draft.heroVideoUrl || ''} onChange={e => set('heroVideoUrl', e.target.value)} placeholder="https://www.youtube.com/watch?v=…" /></Campo>
            <Campo rotulo="Cor do destaque">
              <div style={{ display: 'flex', gap: 8 }}>
                {Object.entries(cursosCores).map(([k, v]) => (
                  <button key={k} onClick={() => set('corDestaque', k)} style={{ width: 30, height: 30, borderRadius: 9, background: v.hex, border: (draft.corDestaque || 'blue') === k ? '2px solid var(--ink)' : '2px solid transparent' }} />
                ))}
              </div>
            </Campo>
            <Campo rotulo="Banner de imagem (abaixo dos cursos)">
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{ width: 110, height: 52, border: '1px dashed var(--line)', borderRadius: 8, overflow: 'hidden', background: draft.bannerDashboardUrl ? `center/contain no-repeat url(${draft.bannerDashboardUrl})` : 'var(--bg)' }} />
                <label className="inep-p1" style={{ display: 'inline-block', cursor: 'pointer', fontSize: 12.5, padding: '6px 12px' }}>
                  {enviando === 'bannerDashboardUrl' ? 'Enviando…' : (draft.bannerDashboardUrl ? 'Trocar banner' : 'Enviar banner')}
                  <input type="file" accept="image/*" hidden onChange={e => { const f = e.target.files?.[0]; e.target.value = ''; enviar(f, 'inep/banners', 'bannerDashboardUrl'); }} />
                </label>
                {draft.bannerDashboardUrl && <span className="inep-lnk" style={{ color: 'var(--coral-deep)', fontSize: 12 }} onClick={() => set('bannerDashboardUrl', '')}>Remover</span>}
              </div>
            </Campo>
          </div>
          <div className="inep-card">
            <h3>Pré-visualização</h3>
            <div className={`inep-hero ${cursosCores[draft.corDestaque || 'blue']?.css || ''}`} style={{ padding: 22, ...estiloPrevia }}>
              <h2 style={{ fontSize: 19 }}>{draft.heroTitulo ?? heroPadrao.titulo}</h2>
              <p style={{ fontSize: 13 }}>{draft.heroTexto ?? heroPadrao.texto}</p>
            </div>
          </div>
        </div>
      )}

      {aba === 'cores' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1.3fr 1fr', gap: 18 }}>
          <div className="inep-card">
            <h3>Cores do tema</h3>
            <p className="inep-sub">Valem em todas as telas do INEP. Fundo, cartões, textos e bordas só valem no tema claro (o modo escuro mantém as cores dele para continuar legível).</p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 10 }}>
              {CORES_TEMA.map(c => (
                <label key={c.v} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 13 }}>
                  <input type="color" value={draft.cores?.[c.v] || c.padrao} onChange={e => setCor(c.v, e.target.value)} style={{ width: 42, height: 32, border: 0, background: 'none', cursor: 'pointer' }} />
                  <span>{c.rotulo}</span>
                </label>
              ))}
            </div>
            <button className="inep-add-aula" style={{ marginTop: 14 }} onClick={() => { if (window.confirm('Voltar todas as cores ao padrão?')) set('cores', {}); }}>↺ Voltar às cores padrão</button>
            <h3 style={{ marginTop: 22 }}>Logo</h3>
            <p className="inep-sub">Aparece no topo do menu lateral, no lugar da letra. Prefira imagem quadrada com fundo transparente.</p>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <div style={{ width: 56, height: 56, borderRadius: 12, border: '1px dashed var(--line)', background: draft.logoUrl ? `center/contain no-repeat url(${draft.logoUrl}) #fff` : 'var(--bg)' }} />
              <label className="inep-p1" style={{ display: 'inline-block', cursor: 'pointer', fontSize: 12.5, padding: '6px 12px' }}>
                {enviando === 'logoUrl' ? 'Enviando…' : (draft.logoUrl ? 'Trocar logo' : 'Enviar logo')}
                <input type="file" accept="image/*" hidden onChange={e => { const f = e.target.files?.[0]; e.target.value = ''; enviar(f, 'inep/marca', 'logoUrl'); }} />
              </label>
              {draft.logoUrl && <span className="inep-lnk" style={{ color: 'var(--coral-deep)', fontSize: 12 }} onClick={() => set('logoUrl', '')}>Remover</span>}
            </div>
          </div>
          <div className="inep-card">
            <h3>Pré-visualização</h3>
            <div className="inep-app" data-theme="light" style={{ ...estiloPrevia, borderRadius: 14, overflow: 'hidden', border: '1px solid var(--line)' }}>
              <div style={{ display: 'flex', minHeight: 220 }}>
                <div style={{ width: 90, background: 'linear-gradient(180deg,var(--navy),var(--navy2))', padding: 10, color: '#fff', fontSize: 11 }}>
                  <div style={{ width: 34, height: 34, borderRadius: 9, background: draft.logoUrl ? `center/contain no-repeat url(${draft.logoUrl}) #fff` : 'var(--blue)', marginBottom: 10 }} />
                  <div style={{ opacity: .8 }}>Menu</div>
                </div>
                <div style={{ flex: 1, background: 'var(--bg)', padding: 14 }}>
                  <div style={{ color: 'var(--ink)', fontWeight: 700, marginBottom: 4 }}>Título da tela</div>
                  <div style={{ color: 'var(--muted)', fontSize: 12, marginBottom: 10 }}>Texto secundário</div>
                  <div style={{ background: 'var(--card)', border: '1px solid var(--line)', borderRadius: 10, padding: 10, marginBottom: 10, color: 'var(--ink)', fontSize: 12.5 }}>Cartão de exemplo</div>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                    <span style={{ background: 'var(--blue)', color: '#fff', borderRadius: 8, padding: '6px 10px', fontSize: 12 }}>Botão</span>
                    {['--coral', '--sun', '--mint', '--purple', '--cyan'].map(v => <span key={v} style={{ width: 22, height: 22, borderRadius: 6, background: `var(${v})` }} />)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {aba === 'textos' && (
        <div>
          <input value={buscaTexto} onChange={e => setBuscaTexto(e.target.value)} placeholder="🔍 Procurar texto" style={{ padding: '8px 12px', border: '1.5px solid var(--line)', borderRadius: 10, minWidth: 260, margin: '4px 0 12px', background: 'var(--card)', color: 'var(--ink)' }} />
          <p className="inep-sub">Deixe em branco para usar o texto padrão (aparece em cinza dentro do campo).</p>
          {GRUPOS_TEXTOS.map(g => {
            const itens = g.itens.filter(([k, rotulo, padrao]) => !q || `${rotulo} ${padrao} ${draft.textos?.[k] || ''}`.toLowerCase().includes(q));
            if (!itens.length) return null;
            return (
              <details key={g.grupo} className="inep-card" open={!!q} style={{ marginBottom: 10 }}>
                <summary style={{ cursor: 'pointer', fontWeight: 700 }}>{g.grupo} <small style={{ color: 'var(--muted)' }}>({itens.length})</small></summary>
                <div style={{ marginTop: 12 }}>
                  {itens.map(([k, rotulo, padrao, longo]) => (
                    <Campo key={k} rotulo={rotulo}>
                      {longo
                        ? <textarea rows={4} value={draft.textos?.[k] || ''} placeholder={padrao} onChange={e => setTexto(k, e.target.value)} />
                        : <input value={draft.textos?.[k] || ''} placeholder={padrao} onChange={e => setTexto(k, e.target.value)} />}
                    </Campo>
                  ))}
                </div>
              </details>
            );
          })}
        </div>
      )}

      {aba === 'quemsomos' && (
        <div>
          <p className="inep-sub">Os textos do "Quem somos" (título, missão, visão, propósito, citação…) ficam na aba <b>Textos</b>, grupo "Quem somos". Aqui ficam as listas.</p>
          <div className="inep-card" style={{ marginBottom: 14 }}>
            <h3>Valores</h3>
            <ListaEditavel itens={draft.quemSomos?.valores?.length ? draft.quemSomos.valores : VALORES_PADRAO} onChange={v => setQS('valores', v)}
              campos={[['cor', 'Cor', 'color', 0], ['titulo', 'Título'], ['texto', 'Texto', 'text', 3]]} novo={() => ({ cor: '#0878b9', titulo: '', texto: '' })} />
          </div>
          <div className="inep-card" style={{ marginBottom: 14 }}>
            <h3>Nossa trajetória</h3>
            <ListaEditavel itens={draft.quemSomos?.timeline?.length ? draft.quemSomos.timeline : TIMELINE_PADRAO} onChange={v => setQS('timeline', v)}
              campos={[['ano', 'Ano'], ['texto', 'Acontecimento', 'text', 4]]} novo={() => ({ ano: '', texto: '' })} />
          </div>
          <div className="inep-card">
            <h3>Nossas unidades</h3>
            <ListaEditavel itens={draft.quemSomos?.unidades?.length ? draft.quemSomos.unidades : UNIDADES_PADRAO} onChange={v => setQS('unidades', v)}
              campos={[['nome', 'Nome'], ['etiqueta', 'Etiqueta'], ['texto', 'Descrição', 'text', 2], ['cor1', 'Cor 1', 'color', 0], ['cor2', 'Cor 2', 'color', 0]]}
              novo={() => ({ nome: '', etiqueta: '', texto: '', cor1: '#075f94', cor2: '#22b8d9' })} />
          </div>
        </div>
      )}

      {aba === 'rodape' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 18 }}>
          <div className="inep-card">
            <h3>Redes sociais</h3>
            <p className="inep-sub">Ícone sem link não aparece no rodapé.</p>
            <Campo rotulo="WhatsApp (número)"><input value={rod.whatsapp} onChange={e => setRod('whatsapp', e.target.value)} placeholder="+5521999999999" /></Campo>
            <Campo rotulo="LinkedIn"><input value={rod.linkedin} onChange={e => setRod('linkedin', e.target.value)} placeholder="linkedin.com/company/..." /></Campo>
            <Campo rotulo="YouTube"><input value={rod.youtube} onChange={e => setRod('youtube', e.target.value)} placeholder="youtube.com/@..." /></Campo>
            <Campo rotulo="Instagram"><input value={rod.instagram} onChange={e => setRod('instagram', e.target.value)} placeholder="instagram.com/..." /></Campo>
            <Campo rotulo="Facebook"><input value={rod.facebook} onChange={e => setRod('facebook', e.target.value)} placeholder="facebook.com/..." /></Campo>
          </div>
          <div className="inep-card">
            <h3>Atendimento</h3>
            <Campo rotulo="Horário"><input value={rod.atendimento} onChange={e => setRod('atendimento', e.target.value)} /></Campo>
            <Campo rotulo="Telefone / WhatsApp de atendimento"><input value={rod.telefone} onChange={e => setRod('telefone', e.target.value)} /></Campo>
            <Campo rotulo='E-mail do "Fale Conosco"'><input value={rod.emailContato} onChange={e => setRod('emailContato', e.target.value)} placeholder="contato@..." /></Campo>
            <Campo rotulo="CNPJ"><input value={rod.cnpj} onChange={e => setRod('cnpj', e.target.value)} /></Campo>
            <h3 style={{ marginTop: 18 }}>Páginas</h3>
            <ListaEditavel itens={rod.paginas || []} onChange={v => setRod('paginas', v)} campos={[['titulo', 'Título'], ['url', 'Link (https://...)', 'text', 2]]} novo={() => ({ titulo: '', url: '' })} />
          </div>
        </div>
      )}

      <div className="inep-pf-salvar">
        {aviso && <span>{aviso}</span>}
        <button className="inep-p1" style={{ background: 'var(--blue)', color: '#fff', width: 'auto', padding: '11px 24px' }} onClick={salvarTudo}>💾 Salvar personalização</button>
      </div>
    </div>
  );
}
